import * as React from 'react'

import { StyleProps } from '@/components/ui/icons'

export function StopPropagation({
  children,
  ...restProps
}: {
  children: React.ReactNode
} & StyleProps): JSX.Element {
  return (
    <span style={restProps['style']} onClick={(e) => e.stopPropagation()}>
      {children}
    </span>
  )
}
